module.exports = __webpack_public_path__ + "img/bnr-sky-s@2x.52bf06ad.jpg";